(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ring-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ring-configurator')) {
      customElements.define(
        'ring-configurator',
        class extends HTMLElement {
          connectedCallback() {
            this.addEventListener('change', this.updateEstimate);
            this.updateEstimate();
          }

          disconnectedCallback() {
            this.removeEventListener('change', this.updateEstimate);
          }

          updateEstimate = () => {
            if (this.dataset.estimationReady !== 'true') return;

            const sizes = [...this.querySelectorAll('[data-ring-size]')].map((input) => input.value ? Number(input.value) : null);
            const widths = [...this.querySelectorAll('[data-ring-width]')].map((input) => Number(input.value));
            const selectedThickness = this.querySelector('[data-ring-thickness]')?.value;
            const thicknessFactors = JSON.parse(this.dataset.thicknessFactors || '{}') || {};
            const thicknessFactor = Number(thicknessFactors[String(selectedThickness)]) || 1;
            const baseWeight = Number(this.dataset.baseWeight);
            const referenceSize = Number(this.dataset.referenceSize);
            const referenceWidth = Number(this.dataset.referenceWidth);
            const pricePerGram = Number(this.dataset.pricePerGram);
            const weightsBySize = JSON.parse(this.dataset.weightBySize || '{}') || {};
            const weightTolerance = Number(this.dataset.weightTolerance);
            const selectedRings = sizes
              .map((size, index) => ({ size, width: widths[index] }))
              .filter((ring) => Number.isFinite(ring.size));

            if (sizes.length !== 2 || widths.length !== 2 || !baseWeight || !referenceSize || !referenceWidth) return;

            const weightOutput = this.querySelector('[data-ring-weight]');
            const priceOutput = this.querySelector('[data-ring-price]');
            if (selectedRings.length === 0) {
              if (weightOutput) weightOutput.textContent = '—';
              if (priceOutput) priceOutput.textContent = '—';
              return;
            }

            let estimatedWeight;
            if (Object.keys(weightsBySize).length > 0) {
              estimatedWeight = selectedRings.reduce((total, ring) => {
                const singleRingWeight = Number(weightsBySize[String(ring.size)]);
                const ringWeight = Number.isFinite(singleRingWeight)
                  ? singleRingWeight
                  : (baseWeight / 2) * (ring.size / referenceSize);
                return total + ringWeight * (ring.width / referenceWidth) * thicknessFactor;
              }, 0);
            } else if (selectedRings.length === 1) {
              const ring = selectedRings[0];
              estimatedWeight = (baseWeight / 2) * (ring.size / referenceSize) * (ring.width / referenceWidth);
            } else {
              const averageSizeFactor = ((sizes[0] + sizes[1]) / 2) / referenceSize;
              const averageWidthFactor = ((widths[0] + widths[1]) / 2) / referenceWidth;
              estimatedWeight = baseWeight * averageSizeFactor * averageWidthFactor;
            }
            const weightFormat = new Intl.NumberFormat('ro-RO', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            const toleranceFormat = new Intl.NumberFormat('ro-RO', {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            });

            if (weightOutput) {
              const toleranceText = weightTolerance > 0
                ? ` (± ${toleranceFormat.format(weightTolerance)} g)`
                : '';
              weightOutput.textContent = `${weightFormat.format(estimatedWeight)} g${toleranceText}`;
            }
            if (priceOutput && pricePerGram > 0) {
              priceOutput.textContent = new Intl.NumberFormat('ro-RO', {
                style: 'currency',
                currency: 'RON',
                maximumFractionDigits: 0,
              }).format(estimatedWeight * pricePerGram);
            }
          };
        },
      );
    }
  } catch(e) { console.error(e); }
})();

})();
